/*
 * types/services/dr2am.tasks.roles.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {ResponseStateState} from './ResponseStateState';

/**
 * The PbResponseState model module.
 * @module model/PbResponseState
 * @version version not set
 */
export class PbResponseState {
  /**
   * Constructs a new <code>PbResponseState</code>.
   * @alias module:model/PbResponseState
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PbResponseState</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PbResponseState} obj Optional instance to populate.
   * @return {module:model/PbResponseState} The populated <code>PbResponseState</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PbResponseState();
      if (data.hasOwnProperty('state'))
        obj.state = ResponseStateState.constructFromObject(data['state']);
      if (data.hasOwnProperty('msg'))
        obj.msg = ApiClient.convertToType(data['msg'], 'String');
      if (data.hasOwnProperty('code'))
        obj.code = ApiClient.convertToType(data['code'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {module:model/ResponseStateState} state
 */
PbResponseState.prototype.state = undefined;

/**
 * @member {String} msg
 */
PbResponseState.prototype.msg = undefined;

/**
 * @member {Number} code
 */
PbResponseState.prototype.code = undefined;


